
import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogRef
} from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { GlobalService } from '../../services/global.service';


@Component({
    selector: 'custom-dialog',
    templateUrl: './custom-dialog.component.html',
    styleUrl: './custom-dialog.component.scss'
})
export class CustomDialogComponent implements OnInit {
    public readonly payableAmountControl: any = new FormControl('', [Validators.required]);
    @Output() updatedDueAmount = new EventEmitter<any>();

    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: any, payAmount: (amt: any) => void; }, private dialogRef: MatDialogRef<CustomDialogComponent>, private gs: GlobalService) {

    }

    isWrongAmount: boolean = false
    ngOnInit() {
        this.payableAmountControl.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((value: any) => {
            this.data.message.previous_due_amount = this.data.message.net_amount_payable - Number(value);
            if (this.data.message.previous_due_amount <= -1) {
                this.isWrongAmount = true
            } else {
                this.isWrongAmount = false
            }
            // if (value) {
            //     this.data.message.previous_due_amount = 0;
            //     return;
            // }
            // else {
            //     // this.updatedDueAmount.emit(this.data.message.previous_due_amount);
            // }
        });
    }

    async confirm() {

        // if (!this.payableAmountControl.value) {
        //     return;
        // }

        // if (!(this.payableAmountControl.value <= Number(this.data.message.net_amount_payable))) {
        //     return
        // }

        // if (this.payableAmountControl.value < 0) {
        //     return
        // }

        // return
        // closing itself and sending data to parent component
        // this.dialogRef.close({ data: this.payableAmountControl.value });
        this.data.payAmount(this.payableAmountControl.value);
        let user: any = await this.gs.getUserInfo();
        this.data.message['user'] = user

        this.updatedDueAmount.emit(this.data.message.previous_due_amount);
        // this.dialogRef.close({ data:  { updatedDueAmount : this.data.message.previous_due_amount}})
    }
}